//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { CommonServices } from "@/services/CommonServices";
import * as OM from "@/model";
import { apiurl } from '@/config';

class _CrawledUrlClient {

    

                
            getByWebUserId(
                webUserId:string,showSpinner = true): Promise<OM.CrawledUrl[]> {
                        return CommonServices.defaultGet<OM.CrawledUrl[]>(apiurl + 'api/CrawledUrl/GetByWebUserId',{ webUserId }, showSpinner);

                    }
    }

export let CrawledUrlClient = new _CrawledUrlClient();

class _CrawlerActionClient {

    

                
            crawlSingleUrl(
                vm:OM.CrawlUrlRequestVm,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/CrawlerAction/CrawlSingleUrl', vm,{}, showSpinner );

                    }
    

                
            getCrawlerStatus(
                webUserId:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/CrawlerAction/GetCrawlerStatus',{ webUserId }, showSpinner);

                    }
    

                
            isCrawlerFree(
                webUserId:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/CrawlerAction/IsCrawlerFree',{ webUserId }, showSpinner);

                    }
    }

export let CrawlerActionClient = new _CrawlerActionClient();

class _CrawlerConfigClient {

    

                
            getConfig(showSpinner = true): Promise<OM.CrawlerConfig> {
                        return CommonServices.defaultGet<OM.CrawlerConfig>(apiurl + 'api/CrawlerConfig/GetConfig',{  }, showSpinner);

                    }
    

                
            save(
                item:OM.CrawlerConfig,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/CrawlerConfig/Save', item,{}, showSpinner );

                    }
    }

export let CrawlerConfigClient = new _CrawlerConfigClient();

class _CrawlRequestQueueClient {

    

                
            getByWebUserId(
                webUserId:string,showSpinner = true): Promise<OM.CrawlRequestQueue[]> {
                        return CommonServices.defaultGet<OM.CrawlRequestQueue[]>(apiurl + 'api/CrawlRequestQueue/GetByWebUserId',{ webUserId }, showSpinner);

                    }
    }

export let CrawlRequestQueueClient = new _CrawlRequestQueueClient();

class _LocalizedClient {

    

                
            saveAnonymousLocalizedValue(
                item:OM.KeyValuePairOfStringAndString,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/Localized/SaveAnonymousLocalizedValue', item,{}, showSpinner );

                    }
    

                
            saveLocalizedEntity(
                item:OM.LocalizedEntity,showSpinner = true): Promise<string> {
                        return CommonServices.defaultPost<string>(apiurl + 'api/Localized/SaveLocalizedEntity', item,{}, showSpinner );

                    }
    

                
            getAll(showSpinner = true): Promise<OM.LocalizedEntity[]> {
                        return CommonServices.defaultGet<OM.LocalizedEntity[]>(apiurl + 'api/Localized/GetAll',{  }, showSpinner);

                    }
    

                
            getEnabledLanguages(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/Localized/GetEnabledLanguages',{  }, showSpinner);

                    }
    

                
            getSupportedLanguages(showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/Localized/GetSupportedLanguages',{  }, showSpinner);

                    }
    

                
            saveLocalizedValue(
                item:OM.KeyValuePairOfStringAndString,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/Localized/SaveLocalizedValue', item,{}, showSpinner );

                    }
    

                
            editLocalizedValue(
                value:OM.LocalizedEntity,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/Localized/EditLocalizedValue', value,{}, showSpinner );

                    }
    }

export let LocalizedClient = new _LocalizedClient();

class _LoginClient {

    

                
            adminLogin(
                psw:string,showSpinner = true): Promise<OM.LoginResponse> {
                        return CommonServices.defaultGet<OM.LoginResponse>(apiurl + 'api/Login/AdminLogin',{ psw }, showSpinner);

                    }
    

                
            loginFromOnOffice(
                userId:string,
                customerWebId:string,
                apiClaim:string,showSpinner = true): Promise<OM.LoginResponse> {
                        return CommonServices.defaultGet<OM.LoginResponse>(apiurl + 'api/Login/LoginFromOnOffice',{ userId, customerWebId, apiClaim }, showSpinner);

                    }
    

                
            refreshLogin(showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Login/RefreshLogin',{  }, showSpinner);

                    }
    }

export let LoginClient = new _LoginClient();

class _MarketplaceClient {

    

                
            checkSignature(
                message:string,
                signature:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/Marketplace/CheckSignature',{ message, signature }, showSpinner);

                    }
    

                
            getSignature(
                message:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Marketplace/GetSignature',{ message }, showSpinner);

                    }
    

                
            activateMarketplace(
                userSecretKey:string,
                apiToken:string,
                apiClaim:string,
                parameterCacheId:string,
                userId:string,
                customerWebId:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Marketplace/ActivateMarketplace',{ userSecretKey, apiToken, apiClaim, parameterCacheId, userId, customerWebId }, showSpinner);

                    }
    

                
            checkActivation(
                customerWebId:string,showSpinner = true): Promise<boolean> {
                        return CommonServices.defaultGet<boolean>(apiurl + 'api/Marketplace/CheckActivation',{ customerWebId }, showSpinner);

                    }
    

                
            updateApiClaim(
                webUserId:string,
                newApiClaim:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Marketplace/UpdateApiClaim',{ webUserId, newApiClaim }, showSpinner);

                    }
    }

export let MarketplaceClient = new _MarketplaceClient();

class _OnOfficeFieldsClient {

    

                
            getEstateFields(showSpinner = true): Promise<OM.GetFieldsResponseForList[]> {
                        return CommonServices.defaultGet<OM.GetFieldsResponseForList[]>(apiurl + 'api/OnOfficeFields/GetEstateFields',{  }, showSpinner);

                    }
    }

export let OnOfficeFieldsClient = new _OnOfficeFieldsClient();

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}